import { Coding } from "@medplum/fhirtypes";

import { DEFAULT_SERVICE_DATE_TIMEZONE } from "@/shared/practice-timezone";

export interface ServiceDateTimezoneFormValue {
  code: string;
  system: string;
  display: string;
}

/**
 * Normalizes a FHIR timezone coding into the encounter/scheduling form shape.
 *
 * @param timezone Optional timezone coding from FHIR resources or form state.
 * @returns Required coding fields with practice default fallback.
 */
export function toServiceDateTimezoneFormValue(timezone?: Coding): ServiceDateTimezoneFormValue {
  return {
    code: timezone?.code ?? DEFAULT_SERVICE_DATE_TIMEZONE.code,
    system: timezone?.system ?? DEFAULT_SERVICE_DATE_TIMEZONE.system,
    display: timezone?.display ?? timezone?.code ?? DEFAULT_SERVICE_DATE_TIMEZONE.display,
  };
}
